import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import type { JSX } from 'react';
import { LeafIcon } from '../../../components/LeafIcon/LeafIcon.tsx';
import { StyledContainerGrid, StyledGrid } from './styledComponents/GreenDeal.styled.tsx';

export const GreenDeal = (): JSX.Element => {
  const GREEN_DEAL_URL = 'https://www.openx.com/sustainability/';

  return (
    <StyledContainerGrid container>
      <StyledGrid size={10}>
        <LeafIcon />
        <Typography data-test="green-deal-text">This deal is green! Learn more about Sustainability.</Typography>
      </StyledGrid>
      <Grid size={'auto'}>
        <Button
          variant="text"
          color="success"
          data-test="read-more-button"
          onClick={() => window.open(GREEN_DEAL_URL, '_blank')}
        >
          Read More
        </Button>
      </Grid>
    </StyledContainerGrid>
  );
};
